import { MAX_LEVEL } from './constants';

/**
 * Coût L→L+1 : la forme du dossier §4 (100 + 25L + 4L²) divisée par XP_CURVE_DIVISOR et arrondie à l'unité.
 * Léni a choisi d'adoucir la courbe (2026-11-03) ; le diviseur est calibré avec scripts/progression-bench.ts
 * pour que le niveau 60 demande environ 26 min de jeu vivant en farm sans boost (cible du dossier : 20–30 min).
 */
export const XP_CURVE_DIVISOR = 8;

export function xpCostToNext(level: number): number {
  return Math.round((100 + 25 * level + 4 * level * level) / XP_CURVE_DIVISOR);
}

/** XP cumulée nécessaire pour atteindre le niveau L : somme des coûts des niveaux 1 à L−1, C(1) = 0. */
export function xpForLevel(level: number): number {
  let sum = 0;
  for (let l = 1; l < Math.floor(level); l++) sum += xpCostToNext(l);
  return sum;
}

const TABLE: number[] = [];
for (let l = 1; l <= MAX_LEVEL; l++) TABLE.push(xpForLevel(l));

/** Niveau atteint pour une XP cumulée (plafonné à 60 ; l'XP continue au-delà pour le score). */
export function levelForXp(xp: number): number {
  let lo = 1;
  let hi = MAX_LEVEL;
  while (lo < hi) {
    const mid = (lo + hi + 1) >> 1;
    if (TABLE[mid - 1] <= xp) lo = mid;
    else hi = mid - 1;
  }
  return lo;
}

/** Fraction de progression vers le niveau suivant (1 au niveau max). */
export function levelProgress(xp: number): number {
  const l = levelForXp(xp);
  if (l >= MAX_LEVEL) return 1;
  const a = TABLE[l - 1];
  const b = TABLE[l];
  return (xp - a) / (b - a);
}

/** Un point de statistique par niveau de 2 à 60 : 59 au total. */
export function statPointsForLevel(level: number): number {
  return Math.max(0, Math.min(level, MAX_LEVEL) - 1);
}

/** Emplacements de modifications débloqués (dossier §11). */
export const MOD_SLOT_LEVELS = {
  weapon1: 15,
  chassis1: 20,
  passive: 35,
  weapon2: 45,
  chassis2: 50,
} as const;
